import serverRequest from '../utils/Api';
import { URLs } from '../utils/urls';

export const requestAutomaticReport = (state, id) => {
  const { method, url } = URLs.reportRules.getReportRule(id);
  return serverRequest(method, url, state);
};
